export default "__VITE_ASSET__Cd4L4Uok__"